import { Log, apiRequest } from '@ext/utils';
export * from './Usuario.types'
import { IUsuario } from './Usuario.lib';

export class Usuario extends IUsuario {

    public static async create( id: number ): Promise<Usuario> {
        let o = new Usuario();
        o.Id = id;
        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/468486b8d';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }
}